export enum CourierVehicleType {
  Bike = 'BIKE',
  EBike = 'EBIKE',
  Scooter = 'SCOOTER',
  Car = 'CAR',
}

export enum ActiveCourierStatuses {}

export enum CourierReturnStatusType {
  Returning = 'RETURNING',
  Nearby = 'NEARBY',
  Arrived = 'ARRIVED',
}

export enum CourierViewType {
  ListView = 'LISTVIEW',
  ActionView = 'ACTIONVIEW',
}

export enum DashboardServerEventType {
  OrderListSnapshot = 'OrderListSnapshot',
  OrderCreated = 'OrderCreated',
  OrderUpdated = 'OrderUpdated',
  OrderExpired = 'OrderExpired',
  OrderEtaUpdated = 'OrderEtaUpdated',
  OrderEtaListSnapshot = 'OrderEtaListSnapshot',
  CourierListSnapshot = 'CourierListSnapshot',
  CourierStatusListSnapshot = 'CourierStatusListSnapshot',
  CourierStatusUpdated = 'CourierStatusUpdated',
  CourierUpdated = 'CourierUpdated',
  CourierLocationUpdated = 'CourierLocationUpdated',
  RouteListSnapshot = 'RouteListSnapshot',
  RouteUpdated = 'RouteUpdated',
  EtaListSnapshot = 'EtaListSnapshot',
  EtaUpdated = 'EtaUpdated',
  CourierDeleted = 'CourierDeleted',
  NextRouteUpdated = 'NextRouteUpdated',
  NextRouteListSnapshot = 'NextRouteListSnapshot',
  ServerTime = 'Heartbeat',
}

export enum OrderStatus {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
  InDelivery = 'IN_DELIVERY',
  Delivered = 'DELIVERED',
  AssignedToNextPool = 'ASSIGNED_TO_NEXT_POOL',
}

export enum OrderDelayStatus {
  Delayed = 'DELAYED',
}

export enum OrderPaymentStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID',
  Unknown = 'UNKNOWN',
}

export enum DeliveryDashboardScreens {
  MANAGE_DELIVERY_SCREEN = 'MANAGE_DELIVERY',
  ORDER_DETAIL_SCREEN = 'ORDER_DETAIL',
  COURIER_DETAIL_SCREEN = 'COURIER_DETAIL',
  DELIVERY_DATA_SCREEN = 'DELIVERY_DATA_SCREEN',
  MAP_SETTINGS_SCREEN = 'MAP_SETTINGS_SCREEN',
}

export enum DeliveryStatus {
  InDelivery = 'IN_DELIVERY',
  Assigned = 'ASSIGNED',
  Returning = 'RETURNING',
  Arrived = 'ARRIVED',
}
